import { TextField } from "@flat-ui";
import { AnalyticsFeedbackOptionList } from "@components/analytics/in-house/feedback/analytics-feedback-option-list";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import {
  FeedbackStepDefinition,
  FeedbackStepProps,
  SurveyAnswers,
} from "@components/analytics/in-house/feedback/analytics-feedback-types";
import {
  OTHER_VALUE,
  ROLE_OPTIONS,
} from "@components/analytics/in-house/feedback/analytics-feedback-helper";

/** Requires a role to be selected; the "Other" free-text field is optional. */
function isValid(answers: SurveyAnswers): boolean {
  return answers.jobFunction.length > 0;
}

/** Single-select role step with an optional free-text "other" field. */
function AnalyticsFeedbackStep3Content({
  answers,
  onAnswersChange,
}: FeedbackStepProps): JSX.Element {
  const shouldShowOther = answers.jobFunction === OTHER_VALUE;

  return (
    <AnalyticsFeedbackStepLayout title="What best describes your role?">
      <AnalyticsFeedbackOptionList
        options={ROLE_OPTIONS}
        selectedValues={answers.jobFunction ? [answers.jobFunction] : []}
        isMultiSelect={false}
        onToggle={(role) => onAnswersChange({ jobFunction: role })}
      />
      {shouldShowOther && (
        <TextField
          fullWidth
          placeholder="Tell us… (optional)"
          text={answers.jobFunctionOther}
          onTextChanged={(roleOther) =>
            onAnswersChange({ jobFunctionOther: roleOther })
          }
        />
      )}
    </AnalyticsFeedbackStepLayout>
  );
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep3: FeedbackStepDefinition = {
  stepName: "role",
  StepComponent: AnalyticsFeedbackStep3Content,
  isValid,
};
